import {
  EnvelopeIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import VBLiveLogo from "../components/assets/VBLive_Logo.png";
import { useLanguage } from "../context/Language/LanguageContext";
import { sortedReleaseNotes } from "../data/releaseNotes";

const kContactEmail = "vblive@peranasports.com";

function Information() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const releases = sortedReleaseNotes();

  return (
    <div className="flex justify-center py-6">
      <div className="card w-full max-w-3xl bg-base-100 shadow-xl">
        <div className="card-body">
          <div className="flex items-center gap-3">
            <img
              src={VBLiveLogo}
              alt="VBLive"
              width="56"
            //   className="rounded-xl"
            />
            <div>
              <h2 className="card-title">{t("Information")}</h2>
              <p className="text-sm text-base-content/70">
                {t("Copyright © Perana Sports {year}. All rights reserved.").replace(
                  "{year}",
                  year
                )}
              </p>
            </div>
          </div>

          <div className="divider my-2" />

          <div className="flex items-center gap-2">
            <EnvelopeIcon className="w-6 text-success" />
            <h3 className="font-semibold text-lg">{t("Contact us")}</h3>
          </div>
          <p className="text-sm">
            {t("Questions, feedback or suggestions are most welcome.")}
          </p>
          <a
            href={`mailto:${kContactEmail}?subject=${encodeURIComponent("VBLive")}`}
            className="link link-success font-semibold"
          >
            {kContactEmail}
          </a>

          <div className="divider my-2" />

          <div className="flex items-center gap-2">
            <InformationCircleIcon className="w-6 text-info" />
            <h3 className="font-semibold text-lg">{t("Release notes")}</h3>
          </div>
          <div className="space-y-4">
            {releases.map((release) => (
              <div key={release.version}>
                <div className="flex items-baseline gap-2">
                  <span className="badge badge-info badge-sm font-semibold">
                    v{release.version}
                  </span>
                  {release.date && (
                    <span className="text-xs text-base-content/60">
                      {release.date}
                    </span>
                  )}
                </div>
                <ul className="list-disc pl-8 space-y-1 text-sm mt-1">
                  {release.notes.map((note, idx) => (
                    <li key={idx}>{t(note)}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

export default Information;
